<template>
  <div class="car-checkbox" @click="onClick">
    <span class="car-checkbox-item"
         :class="{ 'car-selected': isSelected, 'car-disabled': isDisabled}">
    </span>
    <span v-if="label" class="car-text">
      {{ label }}
    </span>
    <slot name="label" />
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    label: {
      default: null,
      type: String
    },
    isSelected: {
      default: false,
      type: Boolean
    },
    isDisabled: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    }
  }
}
</script>
